var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.courses,"dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }